import { render, staticRenderFns } from "./VForm.vue?vue&type=template&id=f1159790&scoped=true&"
import script from "./VForm.vue?vue&type=script&lang=ts&"
export * from "./VForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1159790",
  null
  
)

export default component.exports